import WorkflowArrow from '@/public/images_pwf/workflow_arrow.svg'
import type { Workflow as WorkflowType } from '@/sanity.types'

type WorkflowProps = {
  value: WorkflowType
}

export function Workflow({ value }: WorkflowProps) {
  const { items } = value

  if (!items || items.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-3xl my-6xl">
      {items.map((item, index) => {
        if (!item || !item.title || !item.description) return null

        return (
          <div
            key={index}
            className="bg-white-default rounded-md p-2xl md:p-4xl flex flex-col md:flex-row gap-lg md:gap-xl items-start"
          >
            <div className="bg-green-100 rounded-full size-[32px] flex items-center justify-center shrink-0">
              <span className="size-body-md text-green-600 font-medium">{index + 1}</span>
            </div>
            <div className="flex flex-col gap-md w-full">
              <p className="size-header-h5 !text-white-950">{item.title}</p>
              <div className="bg-neutral-50 rounded-sm py-md px-lg">
                <p className="size-body-xs !text-white-950">{item.description}</p>
              </div>
              {item.functions && item.functions.length > 0 && (
                <div className="flex flex-wrap items-center gap-md">
                  {item.functions.map((func, funcIndex) => (
                    <div key={funcIndex} className="flex items-center gap-md">
                      <div className="bg-green-50 rounded-full px-lg py-xs">
                        <span className="size-header-h6 text-green-600 font-medium">{func}</span>
                      </div>
                      {funcIndex < item.functions!.length - 1 && (
                        <WorkflowArrow className="text-green-200 w-[14px] h-auto" />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
